// css
import '../../scss/pages/archive-blog.scss';

// utils
import Foundation from '../_utils/foundation';
Foundation();

// libs
import Accordion from '../_libs/Accordion';
import { Modal } from '../_libs/Modal';

document.addEventListener('DOMContentLoaded', () => {
	if (!window.matchMedia('(min-width: 768px)').matches) {
		Accordion({
			base: '.js-accordion-breadcrumbs',
			trigger: '.js-accordion-breadcrumbs-trigger',
			target: '.js-accordion-breadcrumbs-target',
			option: false,
		});
	}

	const menuModal = new Modal({
		modal: '.js-menu',
		open: '.js-menu-button',
		close: '.js-close-button',
		html: 'menu-open',
		globalContainer: '.js-main',
		overlay: '.js-modal-overlay',
	});

	menuModal.init();
});

window.addEventListener('load', () => {});
